<template>
  <div>
    <div class="root mb-3">
      <div class="position-container">
        <div>
          <div class="position">
            {{position}}
          </div>
        </div>
      </div>
      <div class="info-container">
        <div>
          <align-middle>
            <h5 v-if="project" class="m-0"><strong>Project:</strong> {{project}}</h5>
            <h5 v-else class="m-0">{{title}}</h5>
            <div>{{description}}</div>
          </align-middle>
        </div>
      </div>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import AlignMiddle from './AlignMiddle';
	export default {
		name: 'Step',
    components: {AlignMiddle},
		props: {
			position: [Number, String],
			title: String,
			project: String,
			description: String
		}
	};
</script>

<style scoped>
  .root {
    position: relative;
    border-bottom: 1px dashed gray;
    padding-bottom: 10px;
  }

  .position-container {
    position: absolute;
    left: 0;
    top: 0;
  }

  .position {
    display: inline-block;
    border-radius: 100%;
    background: #3383c8;
    padding: 12px 20px;
    color: white;
    font-weight: bold;
    font-size: 1.2em;
  }

  .of {
    font-size: .8em;
    display: none;
    margin-left: -10px;
    margin-bottom: -10px;
  }

  .info-container {
    margin-left: 70px;
  }

  .info-container > div {
    min-height: 50px;
    display: block;
    position: relative;
  }
</style>
